import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import bleedImg from './../images/bleed.jpg';

import './FormCheck.css';

const FormCheck = ({ label, options, handleChange, handleChangeOther }) => {

  return (
    <div className="form-group mb-4">
      <label className="font-weight-bold lead">{label}</label><span title="required" className="text-muted FontAwesome">*</span>
        {(label === "7. Bleed?" || label === "9. Bleed?") 
        ? 
        <>
        <small className="ml-1" data-toggle="modal" data-target="#bleedModal"> 
          <FontAwesomeIcon className="text-muted FontAwesome" icon={faInfoCircle} />
        </small>
        <div className="modal fade" id="bleedModal" tabIndex="-1" role="dialog" aria-labelledby="bleedModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-primary">
                <button type="button" className="close text-light" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Full bleed printing means the edge of the sheet of paper of the final product is fully printed, with no white margin.</p>
                <img className="img-fluid" src={bleedImg} alt="bleed info" />
              </div>
            </div>
          </div>
        </div>  
        </>      
        : 
        null}
      <div className="">
        {options.map(item => {

          const { id, name, value, info } = item;
          const index = options.indexOf(item);
          
          return (
            <div className="form-check" key={index}>
              <input
                type="radio"
                id={id}
                className="form-check-input" 
                name={name} 
                value={value} 
                onChange={(item) => handleChange(item)}
                required
              />
              <label htmlFor={id} className="form-check-label">{value} </label>
              {(info !== undefined)
              ?
              <>
              <small className="ml-1"  title={info}  data-toggle="modal" data-target={`#infoModal-${id}`}> 
                <FontAwesomeIcon className="FontAwesome text-muted" icon={faInfoCircle} />
              </small>
              <div className="modal fade" id={`infoModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`infoModal-${id}Label`} aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header bg-primary">
                      <button type="button" className="close text-light" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                    {info}
                    </div>
                  </div>
                </div>
              </div>  
              </>
              :
              null
              }
              {
                (value === "Custom Sizes" || 
                  value === "Other Quantities" ||
                  value === "Other" ||
                  value === "Need Other Kind of Stock?" ||
                  value === "Other Stocks"
                ) 
                ? 
                <>
                  {/* <i className="ml-1" data-toggle="tooltip" data-html="true" title="Please specify details in the Message section below"> 
                    <FontAwesomeIcon className="text-muted" icon={faInfoCircle} />
                  </i> */}
                  <input type="text" className="form-control mx-1" htmlFor={id} name={`${name}_note`}
                    onChange={(item) => handleChangeOther(item)} 
                    onFocus={(item) => handleChangeOther(item)} 
                  /> 
                </>
                : 
                null
              }
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default FormCheck;